import NavTextButton from "@common/ui/NavTextButton"
import { useStore } from "@state/store"
import { useEffect, useRef, useState } from "react"
import styled from "styled-components/macro"
import gsap from "gsap"
import { EffectFade, Navigation, Pagination } from "swiper/modules"
import Carousel from "@common/components/Carousel"
import { useProjectDataStore } from "@state/projectDataStore"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/effect-fade"
import "swiper/css/navigation"
import "swiper/css/pagination"
import InfoCarousel from "./InfoCarousel"
import InfoCarouselVariant from "./InfoCarouselVariant"
import InfoCarouselVariant2 from "./InfoCarouselVariant2"

const Info2Layout = ({ className, info1Data }) => {
  const contentControls = useStore((s) => s.contentControls)

  return (
    <Wrapper className={className}>
      {className === "first" ? (
        <InfoCarousel info1Data={info1Data} />
      ) : className === "second" ? (
        <InfoCarouselVariant info1Data={info1Data} />
      ) : (
        <InfoCarouselVariant2 info1Data={info1Data} />
      )}
    </Wrapper>
  )
}

export default Info2Layout

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: transparent;
`
